import React from 'react';
import styles from './Performance.module.css';

interface ARMAComponent extends React.FC {
  title?: string;
}

const ARMA: ARMAComponent = () => {
  return (
    <div>
      <div className={styles.metricSection}>
        <div className={styles.sectionTitle}>Metric Description</div>
        <p>
          It is critically important for Enhance Curbside orders to be managed and closed out using the Ace Retailer Mobile Assistant (ARMA). This metric is calculated by dividing the number of Enhanced Curbside orders fulfilled using ARMA by the total number of Enhanced Curbside orders.
        </p>
      </div>

      <div className={styles.metricSection}>
        <div className={styles.sectionTitle}>Supporting Details</div>
        <p>
          Login to ALP prior to clicking the course name or copy &amp; paste the course name below into the search field in ALP once you&apos;ve logged in:
        </p>
        <p>
          <a 
            href="https://acehardware.sabacloud.com/Saba/Web_spf/NA9P1PRD003/app/me/learningeventdetail/cours000000000273743?regId=regdw000000005275005" 
            className={styles.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            Acehardware.com Enhanced Curbside Pick-up
          </a>
        </p>
      </div>

      <div className={styles.metricSection}>
        <div className={styles.sectionTitle}>Goal</div>
        <p>
          100% (all orders are closed using Ace Retailer Mobile Assistant (ARMA))
        </p>
      </div>

      <div className={styles.metricSection}>
        <div className={styles.sectionTitle}>Update Cadence</div>
        <p>
          Metric is current state and updated monthly.
        </p>
      </div>

      <div className={styles.metricSection}>
        <div className={styles.sectionTitle}>Learn More</div>
        <p>
          Designate a &apos;point person&apos; for each shift dedicated to fulfilling .com orders. Using a Mobile device with audible alerting and push notifications ensures you can &quot;answer the call&quot; immediately &amp; seamlessly. Managing speed &amp; inventory accuracy can directly reduce .com order cancellations &amp; elevate a best-in-class web-to-store experience. Stores must validate new orders quickly &amp; maintain consistent &amp; disciplined inventory management.
        </p>
        <br/>
        <p>
          For additional guidance review the{' '}
          <a 
            href="https://acenet.aceservices.com/awor/acehardwarecom-order-management/customer-order-fulfillment" 
            className={styles.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            Ace Way of Retailing acehardware.com fulfillment Store Procedures
          </a>
        </p>
      </div>
    </div>
  );
};

// Attach title as a static property
ARMA.title = 'Enhanced Curbside Orders Closed with ARMA';

export default ARMA;
